import { routes as vTaskCategoryRoutes, ROUTES as TASK_CATEGORY_ROUTES } from './task-category/router'
import { routes as vTaskPriorityRoutes, ROUTES as TASK_PRIORITY_ROUTES } from './task-priority/router'
import { routes as vTaskStateRoutes, ROUTES as TASK_STATE_ROUTES } from './task-state/router'
import { routes as vTaskTagRoutes, ROUTES as TASK_TAG_ROUTES } from './task-tag/router'
import { routes as vTaskRoutes, ROUTES as TASK_ROUTES } from './task/router'

const routes = [
  {
    path: 'task/',
    component: () => import('./TaskWrapper'),
    name: 'task-wrapper',
    meta: {
      requiresAuth: true
    },
    children: [
      ...vTaskCategoryRoutes,
      ...vTaskPriorityRoutes,
      ...vTaskStateRoutes,
      ...vTaskTagRoutes,
      ...vTaskRoutes
    ]
  }
]

const ROUTES = {
  ...TASK_CATEGORY_ROUTES,
  ...TASK_PRIORITY_ROUTES,
  ...TASK_STATE_ROUTES,
  ...TASK_TAG_ROUTES,
  ...TASK_ROUTES
}

export { routes, ROUTES }
